import {
  DateTimeRange,
  FixedDateTimeRange,
} from '@modules/common/components/DateRangePicker/types';
import { getFixedDateTimeRangeFromDateTimeRange } from '@modules/common/utils';
import { TimeUnit } from 'generated/graphql';

export const getNextDuration = (
  duration: DateTimeRange,
  aggregatePeriod?: TimeUnit,
): FixedDateTimeRange => {
  const fixedDateTimeRange = getFixedDateTimeRangeFromDateTimeRange(duration);

  if (aggregatePeriod === TimeUnit.Day) {
    return {
      ...fixedDateTimeRange,
      startAfter: fixedDateTimeRange.startAfter?.add(1, 'day') ?? null,
      endBefore: fixedDateTimeRange.endBefore?.add(1, 'day') ?? null,
    };
  }

  if (aggregatePeriod === TimeUnit.Week) {
    return {
      ...fixedDateTimeRange,
      startAfter: fixedDateTimeRange.startAfter?.add(1, 'week') ?? null,
      endBefore: fixedDateTimeRange.endBefore?.add(1, 'week') ?? null,
    };
  }

  return {
    ...fixedDateTimeRange,
    startAfter: fixedDateTimeRange.startAfter?.add(1, 'month') ?? null,
    endBefore: fixedDateTimeRange.endBefore?.add(1, 'month') ?? null,
  };
};
